import { render, staticRenderFns } from "./PublicAuthPrompt.vue?vue&type=template&id=8567789a&scoped=true"
import script from "./PublicAuthPrompt.vue?vue&type=script&lang=ts"
export * from "./PublicAuthPrompt.vue?vue&type=script&lang=ts"
import style0 from "./PublicAuthPrompt.vue?vue&type=style&index=0&id=8567789a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8567789a",
  null
  
)

export default component.exports